import React from 'react'
import styled from 'styled-components'
import { Typography } from '../'
import { Link, useGlobalLabels } from '@sentecacommerce-theme/lib'
import { IconChevronRight } from '../Icons'

export const Heading = ({
  data,
  className = '',
  as = 'h2',
  small,
  viewAllLabel,
  viewAllLink,
  topTitle,
  isCentered,
}: HeadingProps) => {
  const topSpacing = topTitle ? 'mt-5' : 'my-5 pt-5'
  const { viewAll } = useGlobalLabels()
  return (
    <Container
      isCentered={isCentered}
      className={`${topSpacing}${small ? ' mb-3' : ''}${' ' + className}`}
    >
      <Typography variant={small ? 2 : 4} as={as}>
        <Wrapper data-blogger>{data}</Wrapper>
      </Typography>
      {viewAllLink && (
        <Link href={viewAllLink} passHref>
          <Typography variant="7" as="a">
            <ViewAllContainer>
              {viewAllLabel ?? viewAll}
              <IconChevronRight />
            </ViewAllContainer>
          </Typography>
        </Link>
      )}
    </Container>
  )
}

export type HeadingProps = {
  data: string
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div' | 'small'
  small?: boolean
  viewAllLink?: string
  viewAllLabel?: string
  topTitle?: boolean
  isCentered?: boolean
}

const Container = styled.div<{ isCentered?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isCentered }) =>
    isCentered ? 'center' : 'flex-start'};
  width: 100%;
  color: ${({ theme }) => theme.palette.greyTitle};
`

const Wrapper = styled.span`
  font-weight: normal;
  font-size: 2.2rem;
  color: ${({ theme }) => theme.palette.greyTitle};
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 3.2rem;
    line-height: normal;
  }
`

const ViewAllContainer = styled.span.attrs({
  className: 'ml-4 pl-4',
})`
  border-left: 0.2rem solid ${({ theme }) => theme.palette.lightgrey};
  display: flex;
  min-width: 10rem;
  align-items: center;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 4rem;

  position: relative;
  z-index: 10;

  &:hover {
    text-decoration: underline;
  }

  & svg {
    width: 1.2rem;
    margin-left: 0.4rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    line-height: 1.6;
    font-size: 1.5rem;
    position: relative;
    bottom: -0.2rem;
  }
`
